/**
 * 세션 및 디바이스 정보 관리 유틸리티
 */

const SESSION_ID_KEY = 'sessionId';

/**
 * UUID v4 생성
 */
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * 세션 ID 가져오기 (없으면 생성)
 */
export const getOrCreateSessionId = () => {
  try {
    let sessionId = localStorage.getItem(SESSION_ID_KEY);
    if (!sessionId) {
      sessionId = generateUUID();
      localStorage.setItem(SESSION_ID_KEY, sessionId);
    }
    return sessionId;
  } catch (error) {
    console.warn('[Session] Failed to get/create session ID:', error);
    return generateUUID(); // fallback
  }
};

/**
 * 브라우저 및 OS 정보 파싱
 */
const parseUserAgent = () => {
  const ua = navigator.userAgent;
  
  // 브라우저 감지
  let browser = 'Unknown';
  if (ua.includes('Edg/')) {
    browser = 'Edge';
  } else if (ua.includes('Chrome/')) {
    browser = 'Chrome';
  } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    browser = 'Safari';
  } else if (ua.includes('Firefox/')) {
    browser = 'Firefox';
  } else if (ua.includes('MSIE') || ua.includes('Trident/')) {
    browser = 'IE';
  }

  // OS 감지
  let os = 'Unknown';
  if (ua.includes('Win')) {
    os = 'Windows';
  } else if (ua.includes('Mac')) {
    os = 'macOS';
  } else if (ua.includes('Linux')) {
    os = 'Linux';
  } else if (ua.includes('Android')) {
    os = 'Android';
  } else if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) {
    os = 'iOS';
  }

  return { browser, os };
};

/**
 * 디바이스명 생성
 * 예: "Chrome on macOS", "Safari on iOS"
 */
export const getDeviceName = () => {
  try {
    const { browser, os } = parseUserAgent();
    return `${browser} on ${os}`;
  } catch (error) {
    console.warn('[Session] Failed to get device name:', error);
    return 'Unknown Device';
  }
};

/**
 * 세션 정보 객체 반환
 */
export const getSessionInfo = () => {
  return {
    sessionId: getOrCreateSessionId(),
    deviceName: getDeviceName()
  };
};

/**
 * 세션 ID 초기화 (로그아웃 시 사용)
 */
export const clearSessionId = () => {
  try {
    localStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    console.warn('[Session] Failed to clear session ID:', error);
  }
};
